module.exports = __webpack_public_path__ + "img/no-time-for-chitchat.a98649bc.png";